import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

export function selectorIsSharedFileBusinessCardContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return (
    !!contextType && contextType === SharedFileRequestContextType.BUSINESS_CARD
  );
}
